// extracted by mini-css-extract-plugin
export default {"formHeading":"ZI-z","form":"_I-z","submitBtn":"aJ-z","disabled":"bJ-z","input":"cJ-z","error":"dJ-z","submitMsg":"eJ-z","signIn":"fJ-z"};